import { filter, contains, some } from 'underscore';

export const getUpdateImages = (images, snapshotImages, imageIdsToRemove, imagesToAdd = []) => {
  const imageIdsToRemoveNotInSnapshot = filter(imageIdsToRemove, id => !some(snapshotImages, ({
    IdString,
  }) => IdString === id));

  const newImages = filter(images, ({
    IdString,
  }) => !contains(imageIdsToRemoveNotInSnapshot, IdString)) || [];

  newImages.push(...imagesToAdd);

  return newImages;
};
